<template>
  <div>

    <main role="main">

      <div class="container">

        <div class="row">
          <div class="col-md-12">
            <a class="mt-3 mb-3 d-block" @click="$router.go(-1)">
              <i class="fa fa-chevron-circle-left"></i> {{ $t('text.globals.back') }}
            </a>
          </div>
        </div>

        <div class="row" v-if="Object.keys(nodeData).length > 0">

          <div class="col-md-12">

            <h2 class="preventLongStringOutbreak">
              <i v-if="!deleted" :class="$globalFunctions.getFileTypeIcon(nodeData.content.mimeType)"></i>
              {{ nodeData.properties["cm:title"] }} <span class="badge badge-warning"
                                                          v-if="nodeOriginalData.properties['EH:status_gradiva'] === 3 && !deleted">{{
                $t('text.documentDetails.documentArchived')
              }}</span>
              <span class="badge badge-danger" v-if="deleted">{{ $t('text.documentDetails.documentDeleted') }}</span>
            </h2>
            <h6>
              <b>{{ $t('text.metadata.originalName') }}:
                {{ nodeData.properties["rma:origionalName"] ? nodeData.properties["rma:origionalName"] : '/' }}</b>
            </h6>
            <p class="mb-3">
              <small><span class="pr-2">{{ $t('text.globals.lastChange') }}:</span> <i
                  class="fa fa-calendar text-black-50"></i>
                {{ moment(nodeData.modifiedAt).local().format("DD. MM. YYYY HH:mm:ss") }} <span
                    class="text-black-50">|</span> <i class="fa fa-user text-black-50"></i>
                {{ nodeData.modifiedByUser ? nodeData.modifiedByUser.displayName : '' }}</small>
            </p>
          </div>

        </div>
        <div class="row">

          <loading :active.sync="isLoading"
                   :can-cancel="false"
                   :is-full-page="false"></loading>

          <div class="col-md-8 mb-5">

            <div v-if="Object.keys(nodeData).length > 0">

              <loading :active.sync="isLoadingPreview"
                       :can-cancel="false"
                       :is-full-page="false"></loading>


              <div class="card" v-if="!deleted">

                <div class="card-header">{{ $t('text.globals.documentPreview') }}
                  <button class="float-right" type="button" @click="toggle"><i class="fas fa-expand-arrows-alt"></i>
                  </button>
                </div>

                <div class="card-body bg-light"
                     style="max-height: 1022px; overflow-y: scroll; padding-top: 20px; padding-bottom: 20px;"
                     v-if="$globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) !== 'image' && $globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) !== 'video' && $globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) !== 'audio' && $globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) !== 'html'">

                  <em v-if="!previewAvailable"><i class="fa fa-exclamation-triangle"></i>
                    {{ $t('text.documentDetails.documentPreviewNotAvailableToast.message') }}</em>

                  <fullscreen ref="fullscreen" @change="fullscreenChange">
                    <div v-if="nodeData.content.sizeInBytes < maxFileSizeForPdfPreview">
                      <div v-if="getPreviewIframeContent">


                        <pdf
                            v-for="i in numPages"
                            :key="i"
                            :src="getPreviewIframeContent"
                            :page="i"
                            :rotate="0"
                            style="width: 100%; height: 100%; margin-bottom: 10px"
                        ></pdf>

                      </div>
                    </div>
                    <div v-else>
                      <div class="row">
                        <div class="col-md-2 text-center">
                          <img :src="getPreviewIframeContent" v-if="getPreviewIframeContent"
                               width="100" style="max-width: 100px; height: auto"/>

                          <i v-if="!deleted && !getPreviewIframeContent"
                             :class="$globalFunctions.getFileTypeIcon(nodeData.content.mimeType)"
                             class="fa-4x text-muted"></i>

                        </div>
                        <div class="col-md-10">
                          <div class="alert alert-warning">
                            {{ $t('text.documentDetails.previewTooLarge') }}<br/>
                            <a href="#"
                               @click.stop="downloadFile()">{{ $t('text.documentDetails.previewTooLargeDownload') }}</a>.
                          </div>
                        </div>
                      </div>
                    </div>
                  </fullscreen>
                </div>

                <div class="card-body bg-light" style="max-height: 1022px; overflow-y: auto;"
                     v-if="$globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) == 'video' || $globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) === 'audio'">
                  <fullscreen ref="fullscreen" @change="fullscreenChange">
                    <iframe v-if="getPreviewIframeContent" :src="getPreviewIframeContent"
                            frameborder="0"
                            width="100%" height="1100" allowfullscreen webkitallowfullscreen></iframe>
                  </fullscreen>
                </div>

                <div class="card-body bg-light" style="max-height: 1022px; overflow-y: auto;"
                     v-if="$globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) === 'image'">
                  <fullscreen ref="fullscreen" @change="fullscreenChange">
                    <img :src="getPreviewIframeContent" class="img-responsive" style="width: auto; max-width: 100%;"/>
                  </fullscreen>
                </div>

                <div class="card-body bg-light" style="max-height: 1022px; overflow-y: auto;"
                     v-if="$globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) === 'html'">
                  <fullscreen ref="fullscreen" @change="fullscreenChange">
                    <iframe :src="getPreviewIframeContent" frameborder="0"
                            width="100%" height="1100" allowfullscreen webkitallowfullscreen></iframe>
                  </fullscreen>
                </div>

              </div>
              <div v-else class="card-body">
                <div class="alert alert-info mt-3">
                  <em><i class="fa fa-exclamation-triangle"></i>
                    {{ $t('text.globals.documentPreviewNotAvailable') }}</em>
                </div>
              </div>


            </div>
          </div>


          <div class="col-md-4 mb-5">
            <div class="row">
              <div v-if="Object.keys(nodeData).length > 0">
                <div class="col-md-12">
                  <div v-if="!deleted" class="row">
                    <div class="col-xl-6 col-lg-12 my-lg-2 my-md-2 my-sm-2"
                         v-if="$globalFunctions.checkForPermission('TISKANJE_ENOT')">
                      <a class="btn btn-primary btn-sm text-white d-block"
                         @click="downloadFile()"><i
                          class="fa fa-download"></i>
                        {{ $t('text.globals.download') }}</a>
                    </div>
                    <div class="col-xl-6 col-lg-12 my-lg-2 my-md-2 my-sm-2"
                         v-if="$globalFunctions.checkForPermission('UREDI_META') && nodeOriginalData.properties['EH:status_gradiva'] !== 3">
                      <div class="btn btn-primary btn-sm text-white d-block"
                           @click="$router.push({ name: 'DocumentDetailsEdit', params: { id: fileId} })">
                        <i class="fa fa-edit"></i>
                        {{ $t('text.globals.edit') }}
                      </div>
                    </div>

                    <div class="col-xl-6 col-lg-12 my-lg-2 my-md-2 my-sm-2"
                         v-if="$globalFunctions.checkForPermission('UREDI_META') && $globalFunctions.getAppVersionData('environment') !== 'PROD'">
                      <div class="btn btn-primary btn-sm text-white d-block"
                           @click="$router.push({ name: 'DocumentDetailsEditTestClient', params: { id: fileId} })">
                        <i class="fa fa-edit"></i>
                        {{ $t('text.documentDetails.editTestClient') }}
                      </div>
                    </div>
                    <div class="col-xl-6 col-lg-12 my-lg-2 my-md-2 my-sm-2"
                         v-if="nodeOriginalData.properties && nodeOriginalData.properties['EH:oznaka_povezanega_sistema'] === 'EVIP' && $globalFunctions.getAppVersionData('environment') !== 'PROD'">
                      <div class="btn btn-warning btn-sm text-white d-block"
                           @click="$router.push({ name: 'DocumentEvipTestClient', params: { id: fileId} })">
                        <i class="fa fa-asterisk"></i>
                        {{ $t('text.documentDetails.evipCaptureTestClient') }}
                      </div>
                    </div>

                    <div class="col-xl-6 col-lg-12 my-lg-2 my-md-2 my-sm-2"
                         v-if="nodeOriginalData.properties && nodeOriginalData.properties['EH:oznaka_povezanega_sistema'] !== 'EVIP' && $globalFunctions.getAppVersionData('environment') !== 'PROD'">
                      <div class="btn btn-warning btn-sm text-white d-block"
                           @click="$router.push({ name: 'DocumentCopyToEvipTestClient', params: { id: fileId} })">
                        <i class="fa fa-copy"></i>
                        {{ $t('text.documentDetails.documentMoveTestClient') }}
                      </div>
                    </div>

                    <div class="col-xl-6 col-lg-12 my-lg-2 my-md-2 my-sm-2"
                         v-if="$globalFunctions.checkForPermission('POSR_DOK_IN_META') && $globalFunctions.getAppVersionData('environment') !== 'PROD'">
                      <router-link class="btn btn-primary btn-sm text-whit    e d-block"
                                   :to="{ name: 'DocumentAddVersion', params: { id: fileId }}">
                        <i class="fa fa-upload"></i>
                        {{ $t('text.documentDetails.newVersionUploadTestClient') }}
                      </router-link>
                    </div>

                    <div class="col-xl-6 col-lg-12 my-lg-2 my-md-2 my-sm-2"
                         v-if="$globalFunctions.checkForPermission('UREDI_META') && nodeOriginalData.properties['EH:fizicno_gradivo'] === true && (nodeOriginalData.properties['EH:status_gradiva'] === 3 && !deleted)">
                      <div class="btn btn-primary btn-sm text-white d-block"
                           @click="showChangeStorageLocationModal()">
                        <i class="far fa-compass"></i>
                        {{ $t('text.documentDetails.changeStorageLocation') }}
                      </div>
                    </div>

                    <div class="col-xl-6 col-lg-12 my-lg-2 my-md-2 my-sm-2"
                         v-if="($globalFunctions.checkForPermission('BRISI_IZJEMOMA') &&  nodeOriginalData.properties['EH:status_gradiva'] !== 3) || ($globalFunctions.checkForPermission('BRISI_ENOTE_IZVEN') &&  nodeOriginalData.properties['EH:status_gradiva'] === 3)">
                      <div class="btn btn-danger btn-sm text-white d-block"
                           @click="beforeDeleteItem()">
                        <i class="fa fa-trash"></i>
                        {{ $t('text.globals.delete') }}
                      </div>
                    </div>

                    <div class="col-xl-6 col-lg-12 my-lg-2 my-md-2 my-sm-2"
                         v-if="$globalFunctions.checkForPermission('BRISI_IZJEMOMA') && $globalFunctions.getAppVersionData('environment') !== 'PROD'">
                      <DeleteViaTestClient :uuid="nodeData.id"/>
                    </div>


                  </div>
                </div>


                <div class="row"
                     v-if="nodeOriginalData.properties['EH:rok_hrambe'] === 5 && nodeOriginalData.properties['EH:status_gradiva'] === 3 && $globalFunctions.getAppVersionData('environment') !== 'PROD'">
                  <div class="col-md-12">

                    <div class="alert alert-info m-3">
                      <h5>{{ $t('text.documentDetails.expirationState') }}</h5>

                      <p>rma:recordSearchDispositionActionName:
                        <b>{{ nodeOriginalData.properties['rma:recordSearchDispositionActionName'] }}</b><br/>
                        rma:recordSearchDispositionActionAsOf:
                        <b>{{ nodeOriginalData.properties['rma:recordSearchDispositionActionAsOf'] }}</b></p>

                      <a class="btn btn-info btn-block text-white btn-sm" @click="skipDispositionAction()"
                         v-if="nodeOriginalData.properties['rma:recordSearchDispositionActionName'] !== 'destroy'">
                        {{ $t('text.documentDetails.endCurrentExpirationStep') }}</a>

                      <a class="btn btn-warning btn-sm mt-1" @click="refreshDispositionAction()"
                         v-if="nodeOriginalData.properties['rma:recordSearchDispositionActionName'] !== 'destroy'"><i
                          class="fas fa-sync"></i></a>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 metadataSidebar" ng-if="nodeData" :key="nodeData.id">
                  <div class="mt-3 p-2 bg-light">
                    <div class="row mb-3">
                      <div class="col-md-12">
                        <h5 class="mt-1">{{ $t('text.globals.documentInformation') }}</h5>
                      </div>
                    </div>
                    <dl class="row" id="cm:title">
                      <dt class="col-sm-3">{{ $t('text.metadata.title') }}:</dt>
                      <dd class="col-sm-9">{{ nodeData.properties ? nodeData.properties["cm:title"] : '' }}</dd>
                    </dl>
                    <dl class="row" id="id">
                      <dt class="col-sm-3">{{ $t('text.metadata.id') }}:</dt>
                      <dd class="col-sm-9">{{ nodeData.id }}</dd>
                    </dl>
                    <dl class="row" id="rma:origionalName">
                      <dt class="col-sm-3">{{ $t('text.metadata.originalName') }}:</dt>
                      <dd class="col-sm-9">
                        {{ nodeData.properties["rma:origionalName"] ? nodeData.properties["rma:origionalName"] : '/' }}
                      </dd>
                    </dl>
                    <dl class="row" id="cm:author">
                      <dt class="col-sm-3">{{ $t('text.metadata.author') }}:</dt>
                      <dd class="col-sm-9">{{ nodeData.properties["cm:author"] }}</dd>
                    </dl>
                    <dl class="row" id="cm:description">
                      <dt class="col-sm-12">{{ $t('text.metadata.description') }}:</dt>
                      <dd class="col-sm-12">{{ nodeData.properties["cm:description"] }}
                      </dd>
                    </dl>

                    <div class="row">
                      <div class="col-md-6" v-if="!deleted">
                        <dl class="row" id="content.mimeTypeName">
                          <dt class="col-md-12">{{ $t('text.metadata.mimeTypeName') }}:</dt>
                          <dd class="col-md-12">{{ nodeData.content.mimeTypeName ? nodeData.content.mimeTypeName : nodeData.content.mimeType }}</dd>
                        </dl>
                      </div>
                      <div class="col-md-6" v-if="!deleted">
                        <dl class="row" id="content.sizeInBytes">
                          <dt class="col-md-12">{{ $t('text.metadata.sizeInBytes') }}:</dt>
                          <dd class="col-md-12">{{
                              nodeData.content.sizeInBytes |
                                  prettyBytes
                            }}
                          </dd>
                        </dl>
                      </div>
                    </div>
                    <div class="row mb-0">
                      <div class="col-md-12">
                        <hr/>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <h5 class="mt-1 float-left">{{ $t('text.globals.documentMetadata') }}</h5>

                        <div class="btn btn-primary btn-sm text-white float-right"
                             @click="printDocument()"
                             v-if="$globalFunctions.checkForPermission('TISKANJE_META')">
                          <i class="fa fa-print"></i>
                          {{ $t('text.globals.print') }}
                        </div>
                        <div class="clearfix"></div>
                      </div>
                    </div>

                    <div role="tablist" class="metadataList">


                      <b-card no-body class="mb-1"
                              v-for="(item, index) in nodeData.types" :key="index"
                              v-if="item.name !== 'EH:verzioniranje' && item.name !== 'EH:pretvorjeno_gradivo_assoc_aspect'">
                        <b-card-header header-tag="header" class="p-1" role="tab"
                                       v-b-toggle="'accordion-bd' + index">
                          {{ item.title }} <span
                            v-if="item.title=='E-podpis'"> <small>({{ podpisi.length }})</small></span>

                        </b-card-header>
                        <b-collapse :id="'accordion-bd' + index" accordion="my-accordion"
                                    role="tabpanel">
                          <b-card-body v-if="item.title!='E-podpis'">
                            <dl class="row" :id="innerItem.name"
                                v-for="(innerItem, innerIndex) in item.properties">
                              <div v-if="checkIfVisibleOnGui(innerItem.name)">
                                <dt class="col-sm-12">{{ innerItem.title }} :</dt>

                                <dd v-if="innerItem.name === 'EH:povezave_na_vodilne_dokumente'">
                                  <ol class="pl-3" v-if="linksToParentDocument.length > 0">
                                    <li v-for="item in linksToParentDocument"
                                        :key="item.id"
                                        style="font-size: 13px;">
                                      <div class="btn btn-link text-left py-0 pl-1" @click="goToDocument(item.id)"
                                           style="font-size: 13px;">
                                        <i v-if="item.content"
                                           :class="$globalFunctions.getFileTypeIcon(item.content.mimeType)"></i>
                                        <span>{{ item.properties ? item.properties['cm:title'] : '' }}</span>
                                      </div>
                                    </li>
                                  </ol>
                                  <em v-if="linksToParentDocument.length === 0">
                                    <i class="fa fa-exclamation-triangle"></i>
                                    {{ $t('text.documentDetails.informationCannotBeRetrieved') }}.
                                  </em>
                                </dd>

                                <dd v-if="innerItem.name === 'EH:komponenta_povezave_na_dokumente'">
                                  <ol class="pl-3" v-if="linksToParentDocumentComponents.length > 0">
                                    <li v-for="item in linksToParentDocumentComponents"
                                        :key="item.id"
                                        style="font-size: 13px;">
                                      <div class="btn btn-link text-left py-0 pl-1" @click="goToDocument(item.id)"
                                           style="font-size: 13px;">
                                        <i v-if="item.content"
                                           :class="$globalFunctions.getFileTypeIcon(item.content.mimeType)"></i>
                                        <span>{{ item.properties ? item.properties['cm:title'] : '' }}</span>
                                      </div>
                                    </li>
                                  </ol>
                                  <em v-if="linksToParentDocumentComponents.length === 0">
                                    <i class="fa fa-exclamation-triangle"></i>
                                    {{ $t('text.documentDetails.informationCannotBeRetrieved') }}.
                                  </em>
                                </dd>

                                <dd v-if="innerItem.name === 'EH:komentar_pregleda'">
                                  <ol class="pl-3" v-if="nodeData.properties[innerItem.name].length > 0">
                                    <li class="border-bottom mb-2"
                                        v-for="(item, _index) in nodeData.properties[innerItem.name].slice().reverse()"
                                        :key="'komentar'+_index">{{ item }}
                                    </li>
                                  </ol>
                                </dd>


                                <dd class="col-sm-12" :data-name="innerItem.name"
                                    v-if="innerItem.name !== 'EH:povezave_na_vodilne_dokumente' && innerItem.name !== 'EH:komponenta_povezave_na_dokumente' && innerItem.name !== 'EH:komentar_pregleda'">
                                                                <span v-if="innerItem.dataType === 'd:date'">
                                                                    {{
                                                                    nodeData.properties[innerItem.name] ? moment(nodeData.properties[innerItem.name]).local().format("DD. MM. YYYY") : '/'
                                                                  }}
                                                                </span>
                                  <span v-else-if="innerItem.dataType === 'd:datetime'">
                                                                    {{
                                      nodeData.properties[innerItem.name] ? moment(nodeData.properties[innerItem.name]).local().format("DD. MM. YYYY HH:mm:ss") : '/'
                                    }}
                                                                </span>
                                  <span v-else-if="innerItem.dataType === 'd:boolean'">
                                                                    <span v-if="nodeData.properties[innerItem.name]"><i
                                                                        class="fa fa-check-circle"></i> {{
                                                                        $t('text.globals.yes')
                                                                      }}</span>
                                                                    <span v-if="!nodeData.properties[innerItem.name]"><i
                                                                        class="fa fa-times-circle"></i> {{
                                                                        $t('text.globals.no')
                                                                      }}</span>
                                                                </span>
                                  <span v-else-if="innerItem.name === 'EH:rok_hrambe'">
                                  {{
                                      nodeData.properties[innerItem.name] ? readableRokHrambe(nodeData.properties[innerItem.name]) : '/'
                                    }}
                                </span>
                                  <span v-else>
                                  {{ readableValue(innerItem.name, nodeData.properties[innerItem.name]) }}
                                </span>
                                </dd>
                              </div>
                            </dl>

                            <router-link
                                v-if="nodeData && item.name === 'EH:pretvorba_za_dolgorocno_hrambo' && longStorageDocumentIsAvailable"
                                class="btn btn-primary btn-sm text-white d-block"
                                :to="{name: 'DocumentInLongTermStorageDetails', params: {id: nodeData.id}}"><i
                                class="fa fa-eye"></i> {{ $t('text.documentDetails.documentInLongTermStorageForm') }}
                            </router-link>
                            <router-link
                                v-if="nodeData && item.name === 'EH:pretvorba_za_dolgorocno_hrambo' && nodeData.properties['EH:format_gradiva_preverjen'] === true"
                                class="btn btn-success btn-sm text-white d-block mt-2"
                                :to="{name: 'UploadDocumentInLongTermStorageFormat', params: {id: nodeData.id}}"><i
                                class="fa fa-upload"></i>
                              {{ $t('text.documentDetails.documentInLongTermStorageFormManualAdd') }}
                            </router-link>
                          </b-card-body>

                          <b-card-body v-if="item.title=='E-podpis' && podpisi.length > 0">
                            <div v-for="(podpis,idx) in podpisi" class="card mb-1">
                              <div class="card-body">

                                <small style="margin: 0 -10px 10px -10px;"
                                       class="d-inline-block"><b>{{ $t('text.metadata.signature') }} #{{ idx + 1 }}</b></small>

                                <dl class="row" :id="innerItem.name"
                                    v-for="(innerItem, innerIndex) in item.properties">
                                  <dt class="col-sm-12">{{ innerItem.title }}:</dt>


                                  <dd class="col-sm-12" :data-name="innerItem.name">
                                                                <span v-if="innerItem.dataType === 'd:date'">
                                                                    {{
                                                                    podpis[innerItem.name] ? moment(podpis[innerItem.name]).utc().format("DD. MM. YYYY") : '/'
                                                                  }}
                                                                </span>
                                    <span
                                        v-else-if="innerItem.dataType === 'd:datetime' || ((innerItem.dataType === 'd:text' || innerItem.dataType === 'd:mltext') && (innerItem.name.includes('datum') || innerItem.name.includes('cas') || innerItem.name.includes('velja')))">
                                                                    {{
                                        podpis[innerItem.name] ? moment(podpis[innerItem.name]).utc().format("DD. MM. YYYY HH:mm:ss") : '/'
                                      }}
                                                                </span>
                                    <span v-else-if="innerItem.dataType === 'd:boolean'">
                                                                    <span v-if="podpis[innerItem.name]"><i
                                                                        class="fa fa-check-circle"></i> {{
                                                                        $t('text.globals.yes')
                                                                      }}</span>
                                                                    <span v-if="!podpis[innerItem.name]"><i
                                                                        class="fa fa-times-circle"></i> {{
                                                                        $t('text.globals.no')
                                                                      }}</span>
                                                                </span>
                                    <span v-else>
                                      {{podpis[innerItem.name] ? $globalFunctions.getReadableCodeListValueFromProperty(allMetadataOptions, innerItem.name, podpis[innerItem.name]) : '/'}}
                                    </span>
                                  </dd>
                                </dl>
                              </div>
                            </div>

                            <SignatureValidation v-if="podpisi.length > 0" class="my-2" :uuid="nodeData.id"
                                                 :numberOfSignatures="podpisi.length" :ehrambaSignatureData="podpisi"/>

                          </b-card-body>
                        </b-collapse>
                      </b-card>


                      <b-card no-body class="mb-1"
                              :class="components.length === 0 ? 'opacity50' : ''">
                        <b-card-header header-tag="header" class="p-1" role="tab"
                                       v-b-toggle="'accordion-bd-komponente'">
                          {{ $t('text.metadata.components') }} <small
                            v-if="components.length">({{ components.length }})</small>
                        </b-card-header>
                        <b-collapse :id="'accordion-bd-komponente'" accordion="my-accordion"
                                    role="tabpanel" v-if="components.length">
                          <b-card-body>
                            <ol class="pl-1">
                              <li v-for="component in components"
                                  :key="component.entry.id"
                                  style="font-size: 13px;">
                                <div class="btn btn-link text-left py-0 pl-1" @click="goToDocument(component.entry.id)"
                                     style="font-size: 13px;">
                                  <i v-if="component.entry.content"
                                     :class="$globalFunctions.getFileTypeIcon(component.entry.content.mimeType)"></i>
                                  <span>{{ component.entry ? component.entry.properties['cm:title'] : '' }}</span>
                                </div>
                              </li>
                            </ol>
                          </b-card-body>
                        </b-collapse>
                      </b-card>

                      <b-card no-body class="mb-1"
                              :class="linksToLeadingDocument.length === 0 ? 'opacity50' : ''">
                        <b-card-header header-tag="header" class="p-1" role="tab"
                                       v-b-toggle="'accordion-bd-links'">
                          {{ $t('text.metadata.attachments') }} <small
                            v-if="linksToLeadingDocument.length">({{ linksToLeadingDocument.length }})</small>
                        </b-card-header>
                        <b-collapse :id="'accordion-bd-links'" accordion="my-accordion"
                                    role="tabpanel" v-if="linksToLeadingDocument.length">
                          <b-card-body>
                            <ol class="pl-1">
                              <li v-for="linkToLeadingDocument in linksToLeadingDocument"
                                  :key="linkToLeadingDocument.entry.id"
                                  style="font-size: 13px;">
                                <div class="btn btn-link text-left py-0 pl-1"
                                     @click="goToDocument(linkToLeadingDocument.entry.id)" style="font-size: 13px;">
                                  <i v-if="linkToLeadingDocument.entry.content"
                                     :class="$globalFunctions.getFileTypeIcon(linkToLeadingDocument.entry.content.mimeType)"></i>
                                  <span>{{
                                      linkToLeadingDocument.entry ? linkToLeadingDocument.entry.properties['cm:title'] : ''
                                    }}</span>
                                </div>
                              </li>
                            </ol>
                          </b-card-body>
                        </b-collapse>
                      </b-card>

                    </div>

                    <router-link class="btn btn-sm btn-success text-white btn-block mt-3 mb-3"
                                 v-if="$globalFunctions.checkForPermission('PREGLED_REVIZ_SLED')"
                                 :to="{name: 'AuditLog', params: {uuid: fileId}}"><i class="fa fa-table"></i>
                      {{ $t('text.documentDetails.documentAuditLog') }}
                    </router-link>

                    <a class="btn btn-sm btn-success text-white btn-block mt-3 mb-3"
                       v-if="$globalFunctions.checkForPermission('POROCILO_REVIZ_SLED_NEOMEJENO')"
                       @click="() => { generateDocumentAuditLogReport(); }"><i class="far fa-file-alt"></i>
                      {{ $t('text.documentDetails.documentAuditLogReport') }}</a>

                  </div>
                </div>

              </div>
            </div>
          </div>


        </div>
      </div>

    </main>


    <b-modal ref="deleteArchivedRecord-modal" :title="$t('text.documentDetails.archivedDocumentDeletionModal.title')"
             size="lg">

      <loading :active.sync="isLoading"
               :can-cancel="false"
               :is-full-page="false"></loading>

      <div class="row mb-5">
        <div class="col-md-12 mb-0">

          <p>{{ $t('text.documentDetails.archivedDocumentDeletionModal.prompt1') }}
            <b>{{
                nodeData.properties ? nodeData.properties["cm:title"] : ''
              }}</b>{{ $t('text.documentDetails.archivedDocumentDeletionModal.prompt2') }}
          </p>


          <div class="form-group">
            <label for="reassignComment">{{ $t('text.globals.comment') }}</label>
            <textarea class="form-control" id="reassignComment"
                      name="aspectDescription"
                      rows="5"
                      v-model="deleteArchivedRecordDescription"
            ></textarea>
          </div>

        </div>

      </div>

      <div slot="modal-footer" class="w-100">
        <b-button
            id="deleteArchivedRecordBtn"
            variant="danger"
            class="float-right"
            @click="deleteArchivedRecord()">
          <i class="fa fa-trash"></i> {{ $t('text.globals.delete') }}
        </b-button>

        <b-button
            id="closeDeleteArchivedModal"
            variant="default"
            class="float-right"
            @click="closeModal()">
          {{ $t('text.globals.cancel') }}
        </b-button>
      </div>

    </b-modal>

    <b-modal ref="changeStorageLocation-modal"
             :title="$t('text.documentDetails.archivedDocumentStorageLocationEditModal.title')" size="lg">

      <loading :active.sync="isLoading"
               :can-cancel="false"
               :is-full-page="false"></loading>

      <div class="row">
        <div class="col-md-12 mb-2">

          <div class="alert alert-danger" v-if="showChangeStorageLocationValidation">
            <i class="fa fa-exclamation-triangle d-inline-block mr-3"></i>
            {{ $t('text.documentDetails.archivedDocumentStorageLocationEditModal.allFieldsRequired') }}
          </div>

          <div class="form-group">
            <label
                for="changeStorageLocationSendDate">{{
                $t('text.documentDetails.archivedDocumentStorageLocationEditModal.sendDate')
              }}</label>
            <VueCtkDateTimePicker
                :noLabel="true"
                id="changeStorageLocationSendDate"
                format="YYYY-MM-DDTHH:mm:ss.SSS[Z]"
                formatted="DD.MM.YYYY, HH:mm"
                v-model="changeStorageLocationSendDate"
                :locale="$t('text.globals.datePickerLocale')"
                :button-now-translation="$t('text.globals.now')"
            />
          </div>

          <div class="form-group">
            <label
                for="changeStorageLocationReceieveDate">{{
                $t('text.documentDetails.archivedDocumentStorageLocationEditModal.receivedDate')
              }}</label>
            <VueCtkDateTimePicker
                :noLabel="true"
                id="changeStorageLocationReceieveDate"
                format="YYYY-MM-DDTHH:mm:ss.SSS[Z]"
                formatted="DD.MM.YYYY, HH:mm"
                v-model="changeStorageLocationReceieveDate"
                :locale="$t('text.globals.datePickerLocale')"
                :button-now-translation="$t('text.globals.now')"
            />
          </div>

          <div class="form-group">
            <label
                for="changeStorageLocationNewLocation">{{
                $t('text.documentDetails.archivedDocumentStorageLocationEditModal.newLocation')
              }}</label>
            <input type="text"
                   id="changeStorageLocationNewLocation"
                   class="form-control"
                   v-model="changeStorageLocationNewLocation"/>
          </div>
        </div>
      </div>

      <div slot="modal-footer" class="w-100">
        <b-button
            id="changeStorageLocationBtn"
            variant="primary"
            class="float-right"
            @click="changeStorageLocation()">
          <i class="fa fa-save"></i> {{ $t('text.globals.save') }}
        </b-button>

        <b-button
            id="closeChangeStorageLocationModal"
            variant="default"
            class="float-right"
            @click="closeModal()">
          {{ $t('text.globals.cancel') }}
        </b-button>
      </div>

    </b-modal>

  </div>
</template>

<script type="text/javascript">
import Vue from 'vue';
import SignatureValidation from '../components/SignatureValidation';
import DeleteViaTestClient from '../components/DeleteViaTestClient';
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import pdf from 'vue-pdf'
import FileSaver from 'file-saver';

export default {
  name: 'DocumentDetails',
  components: {
    Vue,
    SignatureValidation,
    DeleteViaTestClient,
    Loading,
    vSelect,
    pdf
  },

  data() {
    return {
      fileId: this.$route.params.id, //f3bb5d08-9fd1-46da-a94a-97f20f1ef208 (doc) //0957142f-a388-494b-bcd6-ea6f9496a26d (odt) //de0b8c74-4fa2-416f-9bde-4c81e7f7d28f (pdf)
      deleted: false,
      page: 1,
      numPages: 0,
      rotate: 0,
      sites: [],
      user: {},
      error: '',
      nodeOriginalData: {},
      nodeData: {},
      podpisi: [],
      isLoading: true,
      isLoadingPreview: false,
      fileBlob: null,
      filePreviewBlob: null,
      imgThumbnail: null,
      maxFileSizeForPdfPreview: 7000000,
      breadcrumbItems: [
        {
          text: this.$t('text.documentDetails.documentSearch'),
          href: '#/iskanjeDokumentov'
        }
      ],
      renditionRequests: 0,
      allMetadataOptions: [],
      components: [],
      linksToLeadingDocument: [],
      linksToParentDocument: [],
      linksToParentDocumentComponents: [],

      deleteArchivedRecordDescription: '',
      mestoHrambeOptions: [],
      changeStorageLocationNewLocation: '',
      changeStorageLocationSendDate: null,
      changeStorageLocationReceieveDate: null,
      showChangeStorageLocationValidation: false,
      longStorageDocumentIsAvailable: false,
      fullscreen: false,
      previewAvailable: true,
      codeListProperties: []
    };
  },

  beforeCreate: function () {
    document.body.className = 'dashboard';
  },

  watch: {
    '$route': function () {
      this.getNode(this.$route.params.id);
    }
  },

  mounted() {
    const _this = this;

    let p1 = _this.$store.dispatch("retrieveAlfrescoDictionary");
    let p2 = _this.$store.dispatch("retrieveAllMetadataOptions");
    let p3 = _this.$store.dispatch("retrieveCodeListProperties");

    Promise.all([p1, p2, p3]).then(async (values) => {
      _this.allMetadataOptions = await _this.$store.getters.getAllMetadataOptions;
      this.codeListProperties = this.$store.getters.getCodeListProperties;
      _this.getNode(_this.fileId);
    });

  },

  computed: {

    getPreviewIframeContent() {
      const _this = this;

      if (_this.filePreviewBlob !== null) {

        if (_this.nodeData.content.sizeInBytes < _this.maxFileSizeForPdfPreview && _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) !== 'image' && _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) !== 'video' && _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) !== 'audio' && _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) !== 'html') {
          pdf.createLoadingTask(window.URL.createObjectURL(_this.filePreviewBlob)).then(pdf => {
            _this.numPages = pdf.numPages;
          });
        }

        return window.URL.createObjectURL(_this.filePreviewBlob);
      }
    },


  },

  methods: {

    goToDocument(id) {
      this.$router.push({name: 'DocumentDetails', params: {id: id}});
    },

    async getNode(nodeId) {
      const _this = this;
      await axios.get(config.alfrescoCoreApi + 'nodes/' + nodeId, {
        headers: {
          'Cache-Control': 'no-store',
          'Cache-Control': 'no-cache'
        }
      })
          .then((res) => {


            //console.log("Alfresco core api nodes: ", res.data.entry.properties);
            // before setting nodeData replace code list ids with readable content

            _this.nodeOriginalData = res.data.entry;
            _this.nodeData = _this.$globalFunctions.getReadableDocumentMetadataCodeListValues(_this.allMetadataOptions, _.cloneDeep(res.data.entry));

            _this.deleted = _this.nodeData.aspectNames.indexOf('rma:ghosted') > -1 ? true : false;


            // join separated signature data to array of signature objects
            let epodpisi = null;
            let steviloEpodpisov = 0;

            _.each(_this.$store.getters.getAlfrescoDictionary, function (v, k) {
              if (v.name === 'EH:e_podpis') {
                console.log("v", v);
                epodpisi = v.properties;
              }
            });

            steviloEpodpisov = _this.nodeData.properties['EH:stevilo_podpisov'];
            delete epodpisi['EH:stevilo_podpisov'];

            _this.podpisi = [];
            for (let i = 0; i < steviloEpodpisov; i++) {
              let podpis = {};
              _.forOwn(epodpisi, function (v, k) {
                console.log("k", k, "v", _this.nodeData.properties[k][i]);
                podpis[k] = _this.nodeData.properties[k][i];
              });
              _this.podpisi.push(podpis);
            }
            console.log("PODPISI", _this.podpisi);


            _this.getComponents();
            _this.getLinksToLeadingDocument();
            _this.checkIfLongStorageDocumentIsAvailable();

            _.map(res.data.entry.properties['EH:povezave_na_vodilne_dokumente'], function (val) {
              _this.getParentDocument(val);
            });

            _.map(res.data.entry.properties['EH:komponenta_povezave_na_dokumente'], function (val) {
              _this.getParentDocumentComponent(val);
            });

            let types = _.filter(_this.$store.getters.getAlfrescoDictionary, function (v, k) {

              if (_this.nodeData.aspectNames.indexOf(v.name) > -1 && v.name.substring(0, 3) === 'EH:') {
                return true
              } else {
                return false
              }
            });

            _this.nodeData.types = types;
            console.log("types", types);


            _this.isLoading = false;
            console.log("node data: ", _this.nodeData);


            if (!_this.deleted) {
              if (_this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'pdf' ||
                  _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'image' ||
                  _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'audio' ||
                  _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'video' ||
                  _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'html') {


                if (_this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'pdf') {
                  if (_this.nodeData.content.sizeInBytes < _this.maxFileSizeForPdfPreview) {
                    _this.getFileBlob().then(() => {
                      _this.showPreview(false);
                      _this.isLoading = false;
                    });
                  } else {
                    _this.getImgThumbnail().then(() => {
                      _this.isLoading = false;
                    });
                  }
                } else {
                  _this.getFileBlob().then(() => {
                    _this.showPreview(false);
                    _this.isLoading = false;
                  });
                }


              } else { // doc(x), xls(x) etc

                if (_this.nodeData.content.sizeInBytes < _this.maxFileSizeForPdfPreview) {
                  _this.getFilePreview();
                  _this.isLoading = false;
                  _this.isLoadingPreview = false;
                } else {
                  _this.getImgThumbnail().then(() => {
                    _this.isLoading = false;
                  });
                }

              }
            } else {
              _this.isLoading = false;
              _this.isLoadingPreview = false;
            }

            _this.$forceUpdate();

          })
          .catch((error) => {
            console.error(error);

            this.isLoading = false;
          });


    },

    displayReadableCodeListValues() {
      const _this = this;

      _.each(_this.allMetadataOptions, function (val, key) {
        let property = val.property;

        if (_this.nodeData.properties[property]) {
          _this.nodeData.properties[property] = _.find(_this.allMetadataOptions[key].body, {id: _this.nodeData.properties[property]}).description;
        }
      });

    },

    async getFileBlob() {
      const _this = this;

      _this.fileBlob = new Blob([null], null);

      this.isLoading = true;

      await axios.get(config.alfrescoCoreApi + 'nodes/' + _this.nodeData.id + '/content?attachment=true&timestamp=' + _this.moment().valueOf(), {
        method: 'GET',
        headers: {
          'Cache-Control': 'no-store',
          'Cache-Control': 'no-cache'
        },
        responseType: 'blob' //Force to receive data in a Blob Format
      })

          .then((res) => {

            console.log("RESPONSE ", res.data);

            let theBlob = res.data;
            theBlob.lastModifiedDate = new Date();
            theBlob.Date = new Date();

            _this.fileBlob = theBlob;
            _this.isLoading = false;
          })
          .catch((error) => {
            console.error(error);

            _this.isLoading = false;
          });

    },

    getFilePreview() {
      const _this = this;

      axios.get(config.alfrescoThumbnails + '/' + _this.nodeData.id + '/content/thumbnails/pdf?c=force', {
        method: 'GET',
        headers: {
          'Cache-Control': 'no-store',
          'Cache-Control': 'no-cache'
        }
      })
          .then((res) => {
            console.log("res ----->", res);
            _this.showPreview(true);
            _this.previewAvailable = true
          })
          .catch((error) => {
            console.error(error);
            _this.isLoadingPreview = false;
            _this.previewAvailable = false;

            Vue.$toast.open({
              message: this.$t('text.documentDetails.documentPreviewNotAvailableToast.message'),
              type: 'error',
              position: 'top-right'
            });

          });
    },

    async getImgThumbnail() {
      const _this = this;

      console.log("!!!!!! getImgThumbnail");

      await axios.get(config.alfrescoCoreApi + 'nodes/' + _this.nodeData.id + '/renditions/doclib', {
        method: 'GET',
        headers: {
          'Cache-Control': 'no-store',
          'Cache-Control': 'no-cache'
        }
      })

          .then((res) => {
            console.log("RES", res.data.entry.status);
            if (res.data.entry.status === 'CREATED') {
              _this.showImgThumbnail();
            } else {
              _this.retrieveImageThumbnail();
            }
          })
          .catch((error) => {
            console.error(error);

            _this.isLoading = false;
          });
    },

    async retrieveImageThumbnail() {
      const _this = this;

      await axios.post(config.alfrescoCoreApi + 'nodes/' + _this.nodeData.id + '/renditions', {"id": "doclib"})
          .then((res) => {
            console.log("RES", res.data);

            setTimeout(() => {
              _this.showImgThumbnail();
            }, 1000);
          })
          .catch((error) => {
            console.error(error);

            _this.isLoading = false;
          });

    },

    async showImgThumbnail() {
      const _this = this;

      await axios.get(config.alfrescoCoreApi + 'nodes/' + _this.nodeData.id + '/renditions/doclib/content?attachment=false&placeholder=false', {
        method: 'GET',
        headers: {
          'Cache-Control': 'no-store',
          'Cache-Control': 'no-cache'
        },
        responseType: 'blob' //Force to receive data in a Blob Format
      })

          .then((res) => {
            console.log("RES", res.data);

            // _this.imgThumbnail = res.data;
            let theBlob = res.data;
            theBlob.lastModifiedDate = new Date();
            theBlob.Date = new Date();

            _this.filePreviewBlob = theBlob;
            _this.isLoading = false;
            _this.isLoadingPreview = false;

          })
          .catch((error) => {
            console.error(error);

            _this.isLoading = false;
          });
    },

    showPreview(showFromRenditions) {
      const _this = this;

      let getPdfPreview = "";

      if (showFromRenditions) {
        getPdfPreview = config.alfrescoCoreApi + 'nodes/' + _this.nodeData.id + '/renditions/pdf/content?attachment=true&placeholder=false&timestamp=' + _this.moment().valueOf();
      } else {
        getPdfPreview = config.alfrescoCoreApi + 'nodes/' + _this.nodeData.id + '/content?attachment=true&timestamp=' + _this.moment().valueOf();
      }

      _this.filePreviewBlob = new Blob([null], null);

      axios.get(getPdfPreview, {
        method: 'GET',
        headers: {
          'Cache-Control': 'no-store',
          'Cache-Control': 'no-cache'
        },
        responseType: 'blob' //Force to receive data in a Blob Format
      })

          .then((res) => {
            console.log("RES", res.data);

            let theBlob = res.data;
            theBlob.lastModifiedDate = new Date();
            theBlob.Date = new Date();

            _this.filePreviewBlob = theBlob;
            _this.isLoading = false;
            _this.isLoadingPreview = false;
          })
          .catch((error) => {
            console.error(error);

            _this.isLoading = false;
          });

    },

    downloadFile() {
      const _this = this;

      _this.isLoading = true;

      _this.getFileBlob().then(() => {
        FileSaver.saveAs(_this.fileBlob, _this.nodeData.name);
        _this.isLoading = false;
      });


    },

    blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date();
      theBlob.name = fileName;
      return theBlob;
    },

    // TODO
    getRokHrambeReadableLabel(rokHrambeType) {

      if (rokHrambeType == null) {
        return null;
      } else {

        for (let i = 0; i < this.rokHrambe.length; i++) {
          if (this.rokHrambe[i].type.toString() === rokHrambeType.toString()) {
            return this.rokHrambe[i].explanation;
          }

        }

        return null;
      }

    },

    getComponents() {
      const _this = this;

      let query = {
        "query": {
          "query": "EH:komponenta_povezave_na_dokumente:\"" + _this.nodeData.id + "\""
        },
        "include": [
          "properties"
        ]
      };

      axios.post(config.alfrescoSearchApi, query)
          .then((res) => {
            _this.components = _.sortBy(res.data.list.entries,
                function (o) {
                  return o.entry.properties['cm:title'];
                }
            );
          })
          .catch((error) => {
            console.log("error", error);
          });

    },

    getLinksToLeadingDocument() {
      const _this = this;

      let query = {
        "query": {
          "query": "EH:povezave_na_vodilne_dokumente:\"" + _this.nodeData.id + "\""
        },
        "include": [
          "properties"
        ]
      };

      axios.post(config.alfrescoSearchApi, query)
          .then((res) => {
            _this.linksToLeadingDocument = _.sortBy(res.data.list.entries,
                function (o) {
                  return o.entry.properties['cm:title'];
                }
            );
          })
          .catch((error) => {
            console.log("error", error);
          });

    },

    getParentDocument(parentId) {
      const _this = this;

      let query = {query: {"query": "=ID:\"workspace://SpacesStore/" + parentId + "\" AND TYPE:\"cm:content\" AND ASPECT:\"EH:osnovni_podatki\""}};

      axios.post(config.alfrescoSearchApi, query, {
        headers: {
          'Cache-Control': 'no-store',
          'Cache-Control': 'no-cache'
        }
      })
          .then((res) => {
            console.log("RES -->", res.data.list.entries);
            if (res.data.list.entries.length > 0) {
              axios.get(config.alfrescoCoreApi + 'nodes/' + parentId, {
                headers: {
                  'Cache-Control': 'no-store',
                  'Cache-Control': 'no-cache'
                }
              })
                  .then((res) => {
                    _this.linksToParentDocument.push(_this.$globalFunctions.getReadableDocumentMetadataCodeListValues(_this.allMetadataOptions, res.data.entry))
                    _this.linksToParentDocument = _.sortBy(_this.linksToParentDocument);
                  })
                  .catch((error) => {
                    console.error(error);
                  });


            }
          })
          .catch((error) => {
            console.error(error);
          });
    },

    getParentDocumentComponent(parentId) {
      const _this = this;

      let query = {query: {"query": "=ID:\"workspace://SpacesStore/" + parentId + "\" AND TYPE:\"cm:content\" AND ASPECT:\"EH:osnovni_podatki\""}};

      axios.post(config.alfrescoSearchApi, query)
          .then((res) => {
            console.log("RES -->", res.data.list.entries);
            if (res.data.list.entries.length > 0) {
              axios.get(config.alfrescoCoreApi + 'nodes/' + parentId, {
                headers: {
                  'Cache-Control': 'no-store',
                  'Cache-Control': 'no-cache'
                }
              })
                  .then((res) => {
                    _this.linksToParentDocumentComponents.push(_this.$globalFunctions.getReadableDocumentMetadataCodeListValues(_this.allMetadataOptions, res.data.entry))
                    _this.linksToParentDocumentComponents = _.sortBy(_this.linksToParentDocumentComponents);
                  })
                  .catch((error) => {
                    console.error(error);
                  });
            }
          })
          .catch((error) => {
            console.error(error);
          });
    },

    skipDispositionAction() {
      const _this = this;

      axios.post(config.rootEhramba + 'completeNextDispositionAction?nodeId=' + _this.nodeData.id)
          .then((res) => {
            console.log("OK");

            Vue.$toast.open({
              message: this.$t('text.documentDetails.requestSuccessfullySentToast.message'),
              type: 'success',
              position: 'top-right'
            });

          })
          .catch((error) => {
            console.error(error);
          });
    },

    refreshDispositionAction() {
      const _this = this;

      axios.post(config.rootEhramba + 'refreshDispositionActions')
          .then((res) => {
            console.log("OK");
            _this.getNode(_this.nodeData.id);
          })
          .catch((error) => {
            console.error(error);
          });


    },

    closeModal: function () {
      const _this = this;

      if (_this.$refs['deleteArchivedRecord-modal']) {
        _this.$refs['deleteArchivedRecord-modal'].hide();
        _this.deleteArchivedRecordDescription = '';
      }

      if (_this.$refs['changeStorageLocation-modal']) {
        _this.$refs['changeStorageLocation-modal'].hide();
        _this.changeStorageLocationNewLocation = null;
        _this.changeStorageLocationSendDate = null;
        _this.changeStorageLocationReceieveDate = null;
      }
    },

    beforeDeleteItem() {
      const _this = this;


      this.$swal({
        title: this.$t('text.globals.warningTitle'),
        text: this.$t('text.documentDetails.deleteDocumentWarningSwal.prompt') + (_this.nodeData ? _this.nodeData.properties["cm:title"] : "") + "?",
        dangerMode: true,
        buttons: {
          cancel: {
            text: this.$t('text.globals.cancel'),
            value: null,
            visible: true,
            className: "",
            closeModal: true,
          },
          confirm: {
            text: this.$t('text.globals.delete'),
            value: true,
            visible: true,
            className: "",
            closeModal: true
          }
        },
      })
          .then((value) => {

            switch (value) {

              case true:

                _this.deleteItem();

              case null:

                return;

                break;

              default:

            }
          });


    },

    deleteItem() {
      const _this = this;

      _this.isLoading = true;

      let data = {
        "nodeIds": [_this.nodeData.id]
      };

      let gradivoArhivirano = _this.nodeOriginalData.properties['EH:status_gradiva'] === 3;

      // check for attachments
      axios.post(config.rootEhramba + 'prilogeKomponenteCheck', data)
          .then((res) => {
            _this.isLoading = false;


            if (res.data.length > 0) {

              swal({
                title: this.$t('text.documentDetails.selectedDocumentContainsComponentsSwal.title'),
                type: 'error',
                text: '',
                icon: 'warning',
                dangerMode: true,
                buttons: {
                  cancel: {
                    text: this.$t('text.documentDetails.selectedDocumentContainsComponentsSwal.cancelText'),
                    value: null,
                    visible: true,
                    className: "",
                    closeModal: true,
                  },
                  confirm: {
                    text: this.$t('text.documentDetails.selectedDocumentContainsComponentsSwal.confirmText'),
                    value: true,
                    visible: true,
                    className: "",
                    closeModal: true
                  }
                },
              })
                  .then((value) => {

                    switch (value) {

                      case true:
                        if (gradivoArhivirano) {
                          _this.$refs['deleteArchivedRecord-modal'].show();
                        } else {
                          _this.deleteItemAfterConfirmation();
                        }

                        break;

                      case null:
                        break;
                      default:

                    }
                  });

            } else {
              if (gradivoArhivirano) {
                _this.$refs['deleteArchivedRecord-modal'].show();
              } else {
                if (_this.nodeData.properties['EH:komponenta_povezave_na_dokumente'] && _this.nodeData.properties['EH:komponenta_povezave_na_dokumente'].length > 0) {
                  _this.deleteItemAfterConfirmationAsAlfrescoNode();
                } else {
                  _this.deleteItemAfterConfirmation();
                }
              }
            }

          })
          .catch((error) => {
            console.log("error", error);
            _this.isLoading = false;

            Vue.$toast.open({
              message: this.$t('text.documentDetails.errorWhenGettingComponentInfoToast.message'),
              type: 'error',
              position: 'top-right'
            });

          });


    },

    deleteItemAfterConfirmationAsAlfrescoNode() {
      const _this = this;

      _this.isLoading = true;

      axios.delete(config.alfrescoCoreApi + 'nodes/' + _this.nodeData.id + '?permanent=true')
          .then((res) => {
            console.log("GRADIVO IZBRISANO");
            _this.isLoading = false;
            _this.$router.go(-1);
          })
          .catch((error) => {
            _this.isLoading = false;
            console.error(error);
          });
    },

    deleteItemAfterConfirmation() {
      const _this = this;

      console.log("brisanje NEarhiviranega gradiva");
      console.log("Oznaka povezanega sistema: ", _this.nodeOriginalData.properties['EH:oznaka_povezanega_sistema']);
      _this.isLoading = true;

      axios.delete(config.rootEhramba + 'deleteIncompleteNode?nodeId=' + _this.nodeData.id)
          .then((res) => {
            console.log("GRADIVO IZBRISANO");
            _this.isLoading = false;
            _this.$router.go(-1);
          })
          .catch((error) => {
            _this.isLoading = false;
            console.error(error);
          });

    },


    deleteArchivedRecord() {
      const _this = this;

      _this.isLoading = true;

      let data = {
        "nodeIds": [_this.nodeData.id],
        "irregularDestroyExplanation": _this.deleteArchivedRecordDescription
      };

      axios.post(config.rootEhramba + 'irregularDestroy', data)
          .then((res) => {
            console.log("res", res);
            _this.$router.go(-1);
            console.log("GRADIVO IZBRISANO - TODO: reload z novim podatkov ...");
            _this.isLoading = false;
            _this.closeModal();
          })
          .catch((error) => {
            _this.isLoading = false;
            console.error(error);
          });

    },

    showChangeStorageLocationModal() {
      const _this = this;

      _this.$refs['changeStorageLocation-modal'].show();
    },

    changeStorageLocation() {
      const _this = this;

      _this.showChangeStorageLocationValidation = false;

      if (_this.changeStorageLocationNewLocation === '' || _this.changeStorageLocationSendDate === null || _this.changeStorageLocationReceieveDate === null) {
        _this.showChangeStorageLocationValidation = true;
        return;
      }

      _this.isLoading = true;

      let data = {
        "nodeId": _this.nodeData.id,
        "properties":
            {
              "EH:lokacija_hrambe": _this.changeStorageLocationNewLocation,
              "EH:datum_posiljanja_gradiva_z_lokacije": _this.changeStorageLocationSendDate,
              "EH:datum_sprejema_gradiva_na_lokacijo": _this.changeStorageLocationReceieveDate
            }
      };

      axios.post(config.rootEhramba + 'editClosedRecord', data)
          .then((res) => {
            _this.isLoading = false;
            _this.closeModal();
            Vue.$toast.open({
              message: this.$t('text.documentDetails.storageLocationChangeSuccessfulToast.message'),
              type: 'success',
              position: 'top-right'
            });
            _this.getNode(_this.nodeData.id);
            console.log(res);

          })
          .catch((error) => {
            console.error(error);
            _this.closeModal();
            _this.isLoading = false;
            Vue.$toast.open({
              message: this.$t('text.documentDetails.storageLocationChangeErrorToast.message'),
              type: 'error',
              position: 'top-right'
            });
          });

    },

    printDocument() {
      const _this = this;

      _this.isLoading = true;

      axios
          .get(config.reports + 'printDocumentDetails?nodeId=' + _this.nodeData.id, {
            responseType: "blob",
            headers: {
              'Cache-Control': 'no-store',
              'Cache-Control': 'no-cache'
            }
          })
          .then(res => {
            const url = window.URL.createObjectURL(
                _this.blobToFile(res.data, "Metapodatki")
            );
            const link = document.createElement("a");

            link.href = url;
            link.setAttribute("download", "Metapodatki dokumenta.pdf");
            link.setAttribute("type", "application/pdf");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            _this.isLoading = false;
          })
          .catch(error => {
            _this.isLoading = false;
            console.error(error);
          });


      // let save = document.createElement('a');
      // save.href = config.rootEhramba + 'printDocumentDetails?nodeId=' + _this.nodeData.id;
      // save.target = '_blank';
      // save.download = 'metapodatki.pdf';

      // let evt = new MouseEvent('click', {
      //     'view': window,
      //     'bubbles': true,
      //     'cancelable': false
      // });
      // save.dispatchEvent(evt);

      // (window.URL || window.webkitURL).revokeObjectURL(save.href);

      // setTimeout(function(){
      //     _this.isLoading = false;
      // }, 300);
    },

    async checkIfLongStorageDocumentIsAvailable() {
      const _this = this;

      axios.get(config.rootEhramba + 'longTermConverted?nodeId=' + _this.nodeData.id)
          .then((res) => {
            if (res.data !== null) {
              _this.longStorageDocumentIsAvailable = true;
            } else {
              _this.longStorageDocumentIsAvailable = false;
            }
          })
          .catch((error) => {
            console.log("error", error);
            return false
          });
    },

    toggle() {
      this.$refs['fullscreen'].toggle();
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen
    },
    generateDocumentAuditLogReport() {
      const _this = this;

      let data = {
        "reportType": "REVIZIJSKA_SLED_DOKUMENT",
        "auditReportQuery": {"auditSearchQuery": {"uuid": _this.nodeData.id}}
      };

      _this.$globalFunctions.generateReport(data);
    },

    readableRokHrambe(val) {
      let rokHrambe = val;
      if (typeof val === 'number') {
        rokHrambe = this.$globalFunctions.getReadableCodeListValueFromProperty(this.allMetadataOptions, 'EH:rok_hrambe', parseInt(val));
      }
      return rokHrambe;
    },

    readableValue(property, value) {
      const _this = this;
      if (_this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, property, value) && _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, property, value) !== 'undefined') {
        return _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, property, value)
      } else {
        return value ? value : '/'
      }
    },

    checkIfVisibleOnGui(name) {
      const _this = this;
      let visibleOnGui = false;

      _.map(_this.codeListProperties, function (item) {
        _.filter(item.properties, function (innerItem) {
          if (innerItem.name === name) {
            visibleOnGui = innerItem.showOnGui
          }
        });
      });

      return visibleOnGui;
    }

  }


};
</script>



// WEBPACK FOOTER //
// src/pages/DocumentDetails.vue